<template>
    <transition name="layout-fade">
        <loader v-if="loader"/>
        <v-layout wrap column class="layout-add layout-add--max_width" v-else>
            <v-toolbar text class="v-toolbar--custom">
                <v-toolbar-title>Просмотр промокода "{{ promo.name }}"</v-toolbar-title>
                <v-spacer/>
                <v-btn icon :loading="loading" :disabled="loading" @click="closeLayout">
                    <v-icon>close</v-icon>
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
            </v-toolbar>
            <v-form class="form-add">
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Общее количество:</v-subheader>
                            <p>{{ promo.all_count + promo.bonus_count | formatPrice }}</p>
                            <v-subheader class="pa-0">Начисляемое количество баллов:</v-subheader>
                            <p>{{ promo.bonus_count | formatPrice }}</p>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Использовано на данный момент:</v-subheader>
                            <p>{{ promo.used_count | formatPrice }}</p>
                            <v-subheader class="pa-0">Суммарно начислено баллов:</v-subheader>
                            <p>{{ promo.bonus_count * promo.used_count | formatPrice }}</p>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12 class="mb-3 mt-3">
                    <v-subheader class="pa-0 headline">Cтатистика использований по платформам</v-subheader>
                    <v-layout>
                        <v-flex xs3>
                            <v-subheader class="pa-0">Моб.приложение</v-subheader>
                            <p>{{ promo.used_count_app | formatPrice }}</p>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs3>
                            <v-subheader class="pa-0">Сайт</v-subheader>
                            <p>{{ promo.used_count_site | formatPrice }}</p>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs3>
                            <v-subheader class="pa-0">Бот</v-subheader>
                            <p>{{ promo.used_count_tg | formatPrice }}</p>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-subheader class="pa-0 headline">Пользователи использовавшие промокод</v-subheader>
                    <v-layout>
                        <v-flex xs12>
                            <v-data-table
                                hide-default-footer
                                :headers="headers"
                                :items="promo.used_customers"
                                class="mt-3">
                                <template slot="items" slot-scope="props">
                                    <td>{{ props.index + 1 }}</td>
                                    <td>{{ props.item.name }}</td>
                                    <td>{{ props.item.phone }}</td>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-form>
        </v-layout>
    </transition>
</template>

<script>
    import Promo from '../../../../api/promo'
    import Loader from '../../../../components/Loader/Layout'

    export default {
        name: 'viewPromo',
        components: { Loader },
        data: () => ({
            loader: false,
            loading: false,
            promo: {
                name: '',
                all_count: 0,
                used_count: 0,
                bonus_count: 0,
                used_count_app: 0,
                used_count_site: 0,
                used_count_tg: 0,
                used_customers: [
                    {
                        phone: '',
                        name: ''
                    }
                ]
            },
            headers: [
                {
                    text: '№',
                    value: ''
                },
                {
                    text: 'Имя',
                    value: 'name'
                },
                {
                    text: 'Номер телефона',
                    value: 'phone'
                }
            ]
        }),
        mounted () {
            this.getPromo(this.$route.params.promoCodeId)
        },
        methods: {
            closeLayout () {
                this.$router.push({ name: 'promoCode' })
            },
            getPromo (promoCodeId) {
                this.loader = true

                Promo
                    .getById(promoCodeId)
                    .then(response => this.promo = response.data.data)
                    .catch(error => {
                        this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] })
                        this.$router.push({ name: 'promoCode' })
                    })
                    .finally(() => this.loader = false)
            }
        },
        beforeRouteLeave (to, from, next) {
            next()
        },
        beforeRouteUpdate (to, from, next) {
            this.promo = this.getPromo(to.params.promoCodeId)
            next()
        }
    }
</script>
